// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import animate from 'animate.css'
import { Input, Scrollbar, Loading, InfiniteScroll, Carousel, CarouselItem, Collapse, CollapseItem, Tag } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/style/index.css'
Vue.use(animate)
Vue.config.productionTip = false
Vue.component(Input.name, Input)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Tag)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Scrollbar)
Vue.use(Loading.directive)
Vue.use(InfiniteScroll)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js